import React from "react";
import { Container, Label } from "./styles";

import {
  Dropdown,
} from "semantic-ui-react";

import { limpaTituloCurso } from "../../../utils/Utils";

const CourseAlunoSelector = ({courses, selectedCourseID, onChangeCourseID}) => {

  const onChangeCourse = (e, data) => {
    onChangeCourseID(data?.value);
  }

  const courseOptions = courses
    ?.map((course, index) => {
      return {
        key: index,
        text: `[${course?.id_curso}] ${limpaTituloCurso(course?.curso?.curso)}`,
        value: course?.id_curso,
      }
    });
  
  return (
    <Container>
      <div>
        <Label>Cursos do aluno</Label>
        <Dropdown
          placeholder="Selecione o curso"
          fluid
          search
          selection
          options={courseOptions}
          onChange={onChangeCourse}
          value={selectedCourseID}
        />
      </div>
    </Container>
  );
};

export default CourseAlunoSelector;
